import React, { useState } from 'react';
import { NavbarBrand, Input, FormGroup, Label, Button, Form, Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';
import AccountIcon from '@mui/icons-material/AccountCircle';
import logo from '../images/Cobalt block white logo.png'

const NavMenu = (props) => {

    const [contextIsOpen, setContextIsOpen] = useState(false);

    const toggleContext = () => setContextIsOpen(!contextIsOpen);

    const handleProfileClick = (e) => {
        const id = e.currentTarget.getAttribute('user-id');
        props.actions.getUser(id);
        props.history.push(`/users/user/${id}`);
    }

    const handleSessionChange = (e) => {
        const value = e.target.value;
        props.actions.updateUserContext(value);
    }

    const getSessionsOptions = () => {
        const options = [];
        props.sessions && props.sessions.forEach(session => {
            const { sessionId, name } = session.toJS();
            options.push(<option key={sessionId} value={sessionId}>{name}</option>);
        });
        return options;
    }

    const getUserInfo = () => {
        const context = props.context;
        const user = context && context.get('user');
        const currentSession = user && user.get('claims').find(claim => claim.get('claimType') === 'ACT.CurrentSession');
        const person = user && user.get('person');
        const userDisplayName = person && `${person.get('lastName')}, ${person.get('firstName')}`;
        const imageData = person && person.get('image');
        const profileImage = imageData && `data:image/png;base64, ${imageData}`

        const popover = contextIsOpen ? (
            <div
                style={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    background: 'white',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    padding: '10px',
                    zIndex: 1000,
                    width: '200px'
                }}
            >
                <h3>User Context</h3>
                <Form>
                    <Button
                        color='link'
                        onClick={handleProfileClick}
                        user-id={user.get('id')}
                    >Edit Profile</Button>
                    <FormGroup>
                        <Label>Session Year:</Label>
                        <Input input type='select' onChange={handleSessionChange} value={currentSession && currentSession.get('claimValue')}>
                            {getSessionsOptions()}
                        </Input>
                    </FormGroup>
                </Form>
            </div>
        ) : null;

        return (
            userDisplayName &&
            < div id='profile' className='app-header-accountbox' user-id={user.get('id')} >

                <div className='header-profile align-items-center' onClick={toggleContext}>
                    {profileImage ? <img className='header-profile-image' src={profileImage} alt="not found" height="42" width="42" /> : <AccountIcon />}
                    <span>{userDisplayName}</span>
                </div>
                {popover}
            </div >
        );
    }

    return (props.isAuthenticated &&
        <table className='app-header'>
            <tbody className='app-header-tdbody'>
                <tr>
                    <td className='app-header-logo'>
                        <NavbarBrand tag={Link} to="/programs" id="test">
                            <img src={logo} alt='Logo' style={{ height: '50px' }} />
                        </NavbarBrand>
                    </td>

                    <td className='app-header-account' style={{backgroundColor: '#0074ff'}}>
                        {getUserInfo()}
                    </td>
                </tr>
            </tbody>
        </table>
    );
}

export default NavMenu